<template>
  <BaseCard>
    <BaseCardBody v-if="hasOrder" clear-padding>
      <dl>
        <div class="px-4 py-5 sm:px-6 border-b sm:grid sm:grid-cols-4 sm:gap-4 sm:items-center">
          <dt class="text-sm font-medium text-gray-800">Order</dt>
        </div>
        <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6 sm:items-center">
          <dd class="mt-1 text-sm text-gray-900 sm:mt-0 space-y-1">
            <RouterLink v-if="orderLink" :to="orderLink">
              {{ order.name }}
            </RouterLink>
            <span v-else-if="order">{{ order.name }}</span>
            <span v-else>Order details not available</span>
          </dd>
        </div>
      </dl>
    </BaseCardBody>
    <BaseCardBody v-else>
      <BaseVeeForm :action="createOrder" v-slot="{ isPending, invalid }">
        <BaseButton :disabled="isPending || invalid || hasOrder" primary> Create order </BaseButton>
        <ValidationProvider rules="required" name="offer" slim vid="offer">
          <template #default="{ errors }">
            <BaseFormGroup>
              <BaseFormInput type="hidden" :value="offerId" />
              <BaseFormInlineMessage v-if="errors.length" danger>
                {{ errors[0] }}
              </BaseFormInlineMessage>
            </BaseFormGroup>
          </template>
        </ValidationProvider>
      </BaseVeeForm>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
import makeOfferOrderModule from '@/store/modules/offerOrder';

export default {
  props: {
    offerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modulePath: ['ui', `offer:${this.offerId}:order`],
    };
  },
  computed: {
    offer() {
      return this.$store.state.entities.offers.byId[this.offerId];
    },
    accountRelation() {
      if (!this.offer) {
        return null;
      }
      return this.$store.state.entities.accountRelations.byId[this.offer.accountRelationUuid];
    },
    relatedAccount() {
      if (!this.accountRelation) {
        return null;
      }
      return this.$store.state.entities.accounts.byId[this.accountRelation.related_account_uuid];
    },
    orderId() {
      return this.$store.state.ui?.[`offer:${this.offerId}:order`].orderId;
    },
    order() {
      if (!this.orderId) {
        return null;
      }

      return this.$store.state.entities.orders.byId[this.orderId];
    },
    hasOrder() {
      return typeof this.order === 'object' && this.order !== null;
    },
    orderLink() {
      if ((!this.relatedAccount && !this.offer) || !this.hasOrder) {
        return null;
      }

      return {
        name: 'accounts.orders.show',
        params: {
          accountId: this.relatedAccount.id || this.offer.accountUuid,
          orderId: this.order.uuid,
        },
      };
    },
  },
  created() {
    this.registerModule();
    this.fetchOrder();
  },
  destroyed() {
    this.unregisterModule();
  },
  methods: {
    registerModule() {
      if (!this.$store.hasModule(this.modulePath)) {
        this.$store.registerModule(this.modulePath, makeOfferOrderModule(this.offerId));
      }
    },
    unregisterModule() {
      if (this.$store.hasModule(this.modulePath)) {
        this.$store.unregisterModule(this.modulePath);
      }
    },
    async fetchOrder() {
      try {
        await this.$store.dispatch({
          type: `${this.modulePath.join('/')}/fetchOrder`,
        });
      } catch (error) {
        //
      }
    },
    async createOrder() {
      try {
        await this.$store.dispatch({
          type: `${this.modulePath.join('/')}/storeOrder`,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
